import { PlotDefinition, ChartType } from "../../definitions";
import { VerticalPlotter } from "./verticalPlotter";

export class CategoriesPlotter extends VerticalPlotter {
    protected getPlotDefinitions(): PlotDefinition[] {
        return [this.getBlankPlotDefinition(1)];
    }
}
